<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<script lang="jsx">
import { defineComponent, ref, onMounted, nextTick, watch } from 'vue';

export default defineComponent({
  props: {
    value: {
      type: String,
      default: ''
    },
    row: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: String,
      default: '100%'
    },
    fontSize: {
      type: String,
      default: '14px'
    },
    cursor: {
      type: String,
      default: 'text'
    },
    zIndex: {
      type: [Number, String],
      default: null
    },
    isBold: {
      // 是否需要加粗
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const isShowHover = ref(false);
    const textStyle = ref({
      width: props?.width
    });
    // 获取ref
    const text = ref('');
    const textShow = (el) => {
      text.value = el;
    };

    // 计算样式
    const getStyle = (val) => {
      nextTick(() => {
        if (!text.value) return; // 确保元素已经渲染
        if (text.value?.style?.overflow == 'hidden') return; //确保已经隐藏了
        const lineHeight = getComputedStyle(text.value).lineHeight.replace('px', '') - 0;
        const height = getComputedStyle(text.value).height.includes('px') ? getComputedStyle(text.value).height.replace('px', '') - 0 : getComputedStyle(text.value).height;
        if (height > lineHeight * val) {
          isShowHover.value = true;
          textStyle.value = {
            height: `${lineHeight * val}px`,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            webkitLineClamp: val,
            webkitBoxOrient: 'vertical',
            cursor: 'pointer',
            width: props?.width,
            fontSize: props?.fontSize,
            fontWeight: props?.isBold ? 600 : 400
          };
        } else {
          isShowHover.value = false;
          textStyle.value = {
            cursor: props?.cursor,
            width: props?.width,
            fontSize: props?.fontSize,
            fontWeight: props?.isBold ? 600 : 400
          };
        }
      });
    };
    onMounted(() => {
      getStyle(props?.row);
    });
    // 监听 value 的变化

    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          getStyle(props.row); // 当值发生变化时，重新计算样式
        }
      }
    );
    return () =>
      isShowHover.value ? (
        <jw-tooltip
          style={
            props?.zIndex > 0
              ? {
                  zIndex: props?.zIndex + 3
                }
              : ''
          }
          content={props.value}
        >
          <div ref={textShow} style={textStyle.value}>
            {props.value}
          </div>
        </jw-tooltip>
      ) : (
        <div ref={textShow} style={textStyle.value}>
          {props.value}
        </div>
      );
  }
});
</script>
<style scoped lang="less"></style>
